import { TypeFormWithoutUnresolvableLinksResponse } from "@2u-landing-pages/types";
import { EduListingPayload } from "./eduListing.types";

type BuildEduListingPayloadOptions = {
  imageUrl?: string;
};

export function buildEduListingPayloadFromForm(
  form: TypeFormWithoutUnresolvableLinksResponse,
  options: BuildEduListingPayloadOptions = {}
): EduListingPayload {
  const {
    taxi_package_id,
    main_content,
    footnote: formFootnote,
    button_background_color,
    button_hover_state,
    button_text_color,
    progress_bar_color,
    question_color,
    section_background_color,
    section_background_image,
    enable_multi_column,
  } = form.fields;

  const { heading: formHeading, subhead: formSubhead, body: formBody, image } = main_content?.fields || {};
  const imageUrl = options.imageUrl ?? image?.fields?.file?.url ?? "";

  return {
    image_url: imageUrl,
    title: formHeading ? JSON.stringify(formHeading) : "",
    subtitle: formSubhead ? JSON.stringify(formSubhead) : "",
    body: formBody ? JSON.stringify(formBody) : undefined,
    form_data_package_id: taxi_package_id || "",
    enable_multi_column: enable_multi_column || false,
    main_content: main_content as EduListingPayload["main_content"],
    formFootnote,
    section_background_image,
    colors: {
      button_background_color: button_background_color || "--surface-primary-6",
      button_hover_state,
      button_text_color,
      progress_bar_color,
      question_color,
      section_background_color,
    },
  };
}

export function dispatchEduListingFromForm(
  form: TypeFormWithoutUnresolvableLinksResponse,
  options: BuildEduListingPayloadOptions = {}
): void {
  if (typeof window === "undefined") return;

  const detail = buildEduListingPayloadFromForm(form, options);
  window.dispatchEvent(new CustomEvent("eduListing", { detail }));
}

export function isResolvedFormEntry(entry: unknown): entry is TypeFormWithoutUnresolvableLinksResponse {
  return Boolean(
    entry &&
      typeof entry === "object" &&
      "fields" in entry &&
      (entry as TypeFormWithoutUnresolvableLinksResponse).fields?.taxi_package_id
  );
}
